import { precoProdutoVigente } from './promocao';

export type ProductRequest = { productId: string; requestId: number };

export function cartNumber(value: any): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const text = String(value ?? '').trim();
  return Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text) || 0;
}

export const cartMoney = (value: number) => value.toLocaleString('pt-BR', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});

// Both the catalogue configurator and one-tap offers use this same line format.
export function buildCartItem({ product, category, items, complements = [], massa,
  borda, observation = '', size, flavorCount, weightGrams, quantity = 1,
  unitPrice, priceDate = new Date() }: any) {
  const pizza = category?.tipo === 'pizzas';
  const base = items || [{ id: product.id, descricao: product.nome,
    valor: unitPrice ?? precoProdutoVigente(product, priceDate), categoria: product.categoria, unidadeMedida: product.unidadeMedida }];
  const count = pizza ? (Number(flavorCount) || base.length) : 1;
  const descriptions = base.map((item: any) => ({ ...item,
    descricao: pizza && count > 1 && !/^1\/\d+\s/.test(item.descricao)
      ? `1/${count} ${item.descricao}` : item.descricao,
  }));
  const qtd = Math.max(1, Number(quantity) || 1);
  const price = cartNumber(unitPrice ?? precoProdutoVigente(product, priceDate));
  return {
    productId: base[0]?.id || product?.id,
    tipo: category?.tipo || product?.tipo || 'simples',
    descricao: [...descriptions, ...complements, ...(borda ? [borda] : []),
      ...(massa ? [massa] : []), ...(observation ? [{ descricao: observation,
        valor: '0,00', categoria: 'Observação' }] : [])],
    categoria: category?.nome || product?.categoria,
    nomeCategoria: category?.nome || product?.categoria || 'Item',
    tamanho: size,
    quantidadeSabores: pizza ? count : undefined,
    quantidade: String(qtd), largura: '', comprimento: '',
    unidadeMedida: product?.unidadeMedida || base[0]?.unidadeMedida || 'unid',
    valor: cartMoney(price), desconto: '0', subtotal: cartMoney(price * qtd),
    configuration: {
      flavorIds: pizza ? base.map((item: any) => item.id) : [],
      sizeName: pizza ? size : undefined,
      massaName: massa?.descricao, bordaName: borda?.descricao,
      weightGrams: weightGrams ? cartNumber(weightGrams) : undefined,
      complements: complements.map((item: any) => ({
        groupId: item.groupId, groupIndex: item.groupIndex ?? item.indiceComplemento,
        optionId: item.optionId, optionIndex: item.optionIndex,
        quantity: item.componentQuantity || 1,
      })),
    },
  };
}

export function cartSchedule() {
  return localStorage.getItem('tipoAgendamento') === 'AGENDADO'
    ? { data: localStorage.getItem('dataAgendamento'), hora: localStorage.getItem('horaAgendamento') }
    : undefined;
}
